import React from "react";
import { connect } from "dva";
import { modelUtils, Storage, jsonToString } from "@/utils";
import { Spin } from "antd";
import { utils_tool, component_tool, framework_tool } from "@/tool";
import "./style.less";
const {
  WizCard,
  WizSearchBar,
  WizDataTable,
  WizButton,
  WizModalForm,
  WizAlert,
  WizModalTable,
  WizListSelect,
  WizRow,
  WizCol
} = component_tool;
const { WizContainer } = framework_tool;
const { getPageData } = utils_tool;

import createColumns from "./columns";

class ListSelect extends WizContainer {
  componentName = "ListSelect";

  constructor(props) {
    super(props);
    this.buildActionKey();
    this.state = {
      defaultSearch: true,
      apiParams: {},
      visible: false,
      record: null,
      selectedRows: 0,
      rows: []
    };
  }

  propsAndStateOnChange = {
    updateUser: this._userOnChange.bind(this),
    addUser: this._userOnChange.bind(this)
  };

  _userOnChange(nextProps, nextState) {
    this._getData();
    return true;
  }

  _componentDidMount = () => {
    if (this.state.defaultSearch) {
      this._getData();
    }
  };

  _getData(other = {}) {
    this.doAction({
      path: "userManagement/userList",
      payload: {
        key: "userListKey",
        apiParams: { ...this.state.apiParams, ...other }
      }
    });
  }

  _onUpdate = (record, other = {}) => {
    this.setState({
      record,
      visible: true,
      ...other
    });
  };

  _onDisabled = record => {};

  _onManagement = record => {
    this.setState({
      record,
      visible: true
    });
  };

  _submit = values => {
    if (values.id) {
      this.doAction({
        path: "userManagement/updateUser",
        payload: {
          key: "updateUser",
          apiParams: values
        }
      });
    } else {
      this.doAction({
        path: "userManagement/addUser",
        payload: {
          key: "addUser",
          apiParams: values
        }
      });
    }
    this.setState({
      record: null,
      visible: false
    });
  };

  _removeSelectedRows = () => {
    this.setState({
      selectedRows: 0,
      rows: []
    });
  };

  _handleRowClick() {}

  _render() {
    const { userList, userManagementLoading } = this.props;
    let { record, visible, selectedRows, rows } = this.state;
    let dataItems = getPageData(userList.data);
    let other = {};
    let columns = createColumns(this, dataItems, other);
    let searchBarProps = {
      columns,
      onSearch: values =>
        this.setState({ apiParams: values }, () => {
          this._getData();
        })
    };

    let dataTableProps = {
      loading: userManagementLoading,
      columns,
      rowKey: "personId",
      dataItems,
      selectType: "checkbox",
      showNum: false,
      isScroll: true,
      onChange: ({ pageNum, pageSize }) => {
        this._getData({ current: pageNum, size: pageSize });
      },
      selectedRowKeys: rows.map(item => item.rowKey),
      onSelect: (keys, rows) => {
        this.keys = keys;
        this.setState({
          rows,
          selectedRows: rows.length
        });
      }
    };

    const listSelectProps = {
      type: '人员',
      rows,
      handerClear: id => {
        id
          ? this.setState({
              rows: rows.filter(row => row.id !== id)
            })
          : this.setState({
              rows: []
            });
      }
    };

    return (
      <WizRow>
        <WizCol span={16}>
          <WizCard>
            <WizSearchBar
              type="grid"
              {...searchBarProps}
              cols={{ xs: 14, md: 12, xl: 10 }}
            />
            <WizDataTable style={{ marginTop: 15 }} {...dataTableProps} />
            <div className="pagination">
              <WizDataTable.Pagination {...dataTableProps} />
            </div>
          </WizCard>
        </WizCol>
        <WizCol span={8}>
          <WizListSelect {...listSelectProps} />
        </WizCol>
      </WizRow>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { userManagement } = state;
  const userList = modelUtils.getModelEntity(userManagement, "userListKey");
  const addUser = modelUtils.getModelEntity(userManagement, "addUser");
  const updateUser = modelUtils.getModelEntity(userManagement, "updateUser");
  const load = modelUtils.getLoadingState(state, "userManagement");
  return {
    userList: userList,
    addUser,
    updateUser,
    ...load
  };
};

export default connect(mapStateToProps)(ListSelect);
